import { type UserStatus } from '@aysar/contracts';

import { type BadgeTone } from '@/shared/components/ui/Badge/Badge.tokens';

/**
 * Lifecycle status → badge tone.
 *
 * A domain mapping that two modules now render (P27c1: the staff list and the
 * members list, plus every account cell in a queue), so it is a kit util the
 * way `StatusBadge` is a kit control — the mapping lives beside the control,
 * not in either module (W9, lesson P27b2). `suspended` is a warning and
 * `banned` is a danger because one is reversible and the other is terminal —
 * the colour is carrying a real distinction, not decorating one.
 */
export const STATUS_TONES: Readonly<Record<UserStatus, BadgeTone>> = {
  registered: 'neutral',
  profile_incomplete: 'neutral',
  pending_verification: 'info',
  approved: 'success',
  rejected: 'danger',
  suspended: 'warning',
  banned: 'danger',
};

export function statusTone(status: UserStatus): BadgeTone {
  return STATUS_TONES[status];
}
